import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { AppState } from '@store/app.state';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { GetIntegrationsFailure, GetIntegrationsRequest, GetIntegrationsSuccess } from './actions';
import { GetIntegrationsService } from './service';
import { getIntegrationsGetData } from './selectors';

@Injectable()
export class GetIntegrationsEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store<AppState>);
  private readonly getIntegrationsService = inject(GetIntegrationsService);

  getIntegrations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetIntegrationsRequest),
      withLatestFrom(this.store.pipe(select(getIntegrationsGetData))),
      switchMap(([{ parameters }, data]) => {
        if (!data) {
          return this.getIntegrationsService.getIntegrations(parameters).pipe(
            map(data => GetIntegrationsSuccess({ data })),
            catchError(error => of(GetIntegrationsFailure({ error })))
          );
        }
        return of(GetIntegrationsSuccess({ data }));
      })
    )
  );

}
